module.exports = __webpack_public_path__ + "static/media/trophy.7a10ddfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophy.svg
// module id = 554
// module chunks = 0